import { AvailabilitySource, isStandinDeploymentOrigin, webAvailability } from './availability';

export function localServerLost(
  orgToken: string,
  source: AvailabilitySource,
  nowMs: number
): boolean {
  if (!isStandinDeploymentOrigin(source)) return false;

  return webAvailability(orgToken, source, nowMs).onLocalNetwork === false;
}
